module.exports = __webpack_public_path__ + "media/question2_en.613ed5d5.mp3";